// extracted by mini-css-extract-plugin
module.exports = {"avatarcircle":"avatar_avatarcircle__2H8kr","avatar_component":"avatar_avatar_component__1LrIu","userlogin":"avatar_userlogin__3TXiP"};